<div class="dialog">
  <header class="dialog__header">
    <h3 class="dialog__header__title">{{ data.title | translate }}</h3>
    <div class="dialog__header__action-buttons">
      <div (click)="closeDialog()" class="dialog__header__action-buttons__button">
        <span>
          <app-icon [cssStyle]="{ 'margin-top': '3px' }" iconName="close" size="14px"></app-icon>
        </span>
      </div>
    </div>
  </header>

  <div class="dialog__content">
    <form [formGroup]="inputForm" class="form">
      <div class="input-group full-width-input w-100 --required">
        <label for="input" translate>{{ data.label | translate }}</label>
        @if (data.inputType !== 'textArea') {
          <input formControlName="input" id="input" name="input" type="text" />
        }
        @if (data.inputType === 'textArea') {
          <textarea formControlName="input" id="input" name="input"></textarea>
        }
        <app-form-error [control]="inputForm.get('input')" [name]="data.label | translate"></app-form-error>
      </div>
    </form>
  </div>

  <footer class="dialog__footer">
    <div class="dialog__footer__buttons">
      <app-button
        (click)="closeDialog()"
        [idleText]="'Cancel' | translate"
        [inlineStyle]="{ border: '1px solid var(--gray)' }"
        backgroundColor="var(--white)"
        borderColor="var(--gray)"
        color="var(--dark-charcoal)"
        width="127px"
      ></app-button>
      <app-button (click)="closeDialog('save')" [disabled]="inputForm.invalid || inputForm.pristine" [idleText]="(data.value ? 'Update' : 'Save') | translate" width="127px"></app-button>
    </div>
  </footer>
</div>
